$(window).on('load', function(){
    /* M E N U */
    if($('#header_vape').hasClass('header-vape--home')){
        menu();
    }
    if($('#slider_announcement').length){
        let height = $('#slider_announcement').height();
        if( height > 30 ){
            document.documentElement.style.setProperty("--padding-announcement", `${height}px`);
        }
    }
    menu_desktop();
    menu_mobile();
    /* END M E N U */
});
const menu = () => {
    $(window).scroll(function (event) {
        const nav = $("#header_vape");
        if($(this).scrollTop() > nav.height()){
            nav.addClass('active');
        }else{
            nav.removeClass('active');
        }
    });
}
const menu_desktop = () => {
    $('.trigger_dropdown').on('click', function(){
        let target = $(this).data('drop');
        let submenu = $(this).data('submenu');
        let container = $(`#${submenu}`).find(`div[data-drop="${target}"]`);
        let lazyloadImages = document.querySelectorAll("img.lazymenu");

        lazyloadImages.forEach(function(img) {
            img.src = img.dataset.src;
            img.classList.remove('lazymenu');
        });

        if( $(this).data('status') == 'open' && $(`#${submenu}`).data('status') == 'open'){
            $(this).attr('data-status', 'close');
            $(this).data('status', 'close');
            $(`#${submenu}`).fadeOut(100).removeClass('active');
            $(`#${submenu}`).attr('data-status', 'close');
            $(`#${submenu}`).data('status', 'close');
            $("#MainContent").removeClass('submenu-active');
            $("#MainContent").attr('data-submenu', '');
            $("#submenu_grid_close").attr('data-submenu', '');
            $("#MainContent").data('status', '');
            $("#submenu_grid_close").data('status', '');
            $('#submenu_grid').removeClass('open');
            $('.header-vape__submenu-container').animate({
                right: '-100%'
            }).removeClass('active');
            $('.submenu_dropdown_trigger').removeClass('stop hide');
        }else if( $(this).data('status') == 'close' && $(`#${submenu}`).data('status') == 'open'){
            $('.trigger_dropdown').attr('data-status', 'close');
            $('.trigger_dropdown').data('status', 'close');
            $(this).attr('data-status', 'open');
            $(this).data('status', 'open');
            $(container).addClass('active');
            $("#MainContent").addClass('submenu-active');
            $("#MainContent").attr('data-submenu', submenu);
            $("#submenu_grid_close").attr('data-submenu', submenu);
            $("#MainContent").data('status', submenu);
            $("#submenu_grid_close").data('status', submenu);
        }else if( $(this).data('status') == 'open' && $(`#${submenu}`).data('status') == 'close'){
            $(this).attr('data-status', 'close');
            $(this).data('status', 'close');
            $("#MainContent").removeClass('submenu-active');
            $("#MainContent").attr('data-submenu', '');
            $("#submenu_grid_close").attr('data-submenu', '');
            $("#MainContent").data('status', '');
            $("#submenu_grid_close").data('status', '');
            $('#submenu_grid').removeClass('open');
            $('.header-vape__submenu-container').animate({
                right: '-100%'
            }).removeClass('active');
            $('.submenu_dropdown_trigger').removeClass('stop hide');
        }else if( $(this).data('status') == 'close' && $(`#${submenu}`).data('status') == 'close'){
            $('.trigger_dropdown').attr('data-status', 'close');
            $('.trigger_dropdown').data('status', 'close');
            $(this).attr('data-status', 'open');
            $(this).data('status', 'open');
            $(`#${submenu}`).fadeIn(200).addClass('active');
            $(`#${submenu}`).attr('data-status', 'open');
            $(`#${submenu}`).data('status', 'open');
            $(container).addClass('active');
            $("#MainContent").addClass('submenu-active');
            $("#MainContent").attr('data-submenu', submenu);
            $("#submenu_grid_close").attr('data-submenu', submenu);
            $("#MainContent").data('status', submenu);
            $("#submenu_grid_close").data('status', submenu);
        }
    });
    $('#MainContent').click(function(e){
        if( $(this).hasClass('submenu-active') ){
            e.preventDefault();
            e.stopPropagation();
            let submenu = $(this).data('submenu');
            $(`#${submenu}`).fadeOut(100).removeClass('active');
            $(`#${submenu}`).attr('data-status', 'close');
            $(`#${submenu}`).data('status', 'close');
            $('.trigger_dropdown').attr('data-status', 'close');
            $('.trigger_dropdown').data('status', 'close');
            $("#MainContent").removeClass('submenu-active');
            $("#MainContent").attr('data-submenu', '');
            $("#MainContent").data('status', '');
            $('#submenu_grid').removeClass('open');
            $('.header-vape__submenu-container').animate({
                right: '-100%'
            }).removeClass('active');
            $('.submenu_dropdown_trigger').removeClass('stop hide');
        }
    });
    $('#submenu_grid_close').click(function(e){
        console.log('clic cerrar')
        e.preventDefault();
        e.stopPropagation();
        let submenu = $(this).data('submenu');
        $(`#${submenu}`).fadeOut(100).removeClass('active');
        $(`#${submenu}`).attr('data-status', 'close');
        $(`#${submenu}`).data('status', 'close');
        $('.trigger_dropdown').attr('data-status', 'close');
        $('.trigger_dropdown').data('status', 'close');
        $("#MainContent").removeClass('submenu-active');
        $("#MainContent").attr('data-submenu', '');
        $("#MainContent").data('status', '');
        $(this).attr('data-submenu', '');
        $(this).data('status', '');
        $('#submenu_grid').removeClass('open');
        $('.header-vape__submenu-container').animate({
            right: '-100%'
        }).removeClass('active');
        $('.submenu_dropdown_trigger').removeClass('stop hide');
    });

    $('.submenu_dropdown_trigger').on('click', function(){
        console.log('click')
        $('#submenu_grid').addClass('open')
        let drop = $(this).data('drop');
        let target = $('#submenu_grid').find(`.header-vape__submenu-container[data-drop="${drop}"]`);
        let menus = $('#submenu_grid').find('.submenu_dropdown_trigger');
        Array.from(menus).forEach( (el) => {
            if ( $(el).data('drop') === drop ){
                $(el).addClass('stop');
            }else{
                $(el).addClass('hide');
            }
        })
        $(target).animate({
            right: '0'
        }).addClass('active');
    })
    $('.btn_dropdown_close').on('click', function(){
        let drop = $(this).data('drop');
        let target = $('#submenu_grid').find(`.header-vape__submenu-container[data-drop="${drop}"]`);
        let menus = $('#submenu_grid').find('.submenu_dropdown_trigger');
        $('#submenu_grid').removeClass('open');
        Array.from(menus).forEach( (el) => {
            if ( $(el).data('drop') === drop ){
                $(el).removeClass('stop');
            }else{
                $(el).removeClass('hide');
            }
        });
        $(target).animate({
            right: '-100%'
        }).delay(100).removeClass('active');
    })
}

const menu_mobile = () => {
    $('#trigger_menu_mobile').on('click', function(){
        if( $('#header_vape').hasClass('header-vape--home') ){
            $('#header_vape').addClass('active');
        }
        if( $('#bundle-builder-app--bundle--alert').length ){
            $('#bundle-builder-app--bundle--alert').toggleClass('hide');
        }
        if( $('#wa-chat-btn-root').length){
            $('#wa-chat-btn-root').toggleClass('hide');
        }
        if($('#slider_announcement').length){
            $('#slider_announcement_wrapper').toggleClass('hide-a');
            $('#slider_announcement').toggleClass('hide-a');
            $('#header_vape').toggleClass('announcement');
        }
        $(this).toggleClass('active');
        $('#target_menu_mobile').fadeToggle(500).toggleClass('active');
    });
    $('.has_submenu_mobile').on('click', function(){
        let submenu = $(this).siblings('.hidden_content');
        let lazyloadImages = document.querySelectorAll("img.lazymenumobile");

        lazyloadImages.forEach(function(img) {
            img.src = img.dataset.src;
            img.classList.remove('lazymenumobile');
        });
        if( $(this).data('status') == 'close' ){
            $('.has_submenu_mobile').removeClass('active');
            $('.hidden_content').removeClass('active');
            $('.has_submenu_mobile').attr('data-status', 'close');
            $('.hidden_content').attr('data-status', 'close');
            $('.has_submenu_mobile').data('status', 'close');
            $('.hidden_content').data('status', 'close');
            $(this).addClass('active');
            $(submenu).addClass('active');
            $(this).attr('data-status', 'open');
            $(submenu).attr('data-status', 'open');
            $(this).data('status', 'open');
            $(submenu).data('status', 'open');
        }else{
            $(this).removeClass('active');
            $(submenu).removeClass('active');
            $(this).attr('data-status', 'close');
            $(submenu).attr('data-status', 'close');
            $(this).data('status', 'close');
            $(submenu).data('status', 'close');
            $('#submenu_grid_mobile').removeClass('open');
            $('.header-vape__submenu-container').animate({
                right: '-100%'
            }).removeClass('active');
            $('.submenu_dropdown_trigger_mobile').removeClass('stop hide');
        }
    })
    $('.submenu_dropdown_trigger_mobile').on('click', function(){
        console.log('click')
        $('#submenu_grid_mobile').addClass('open')
        let drop = $(this).data('drop');
        let target = $('#submenu_grid_mobile').find(`.header-vape__submenu-container[data-drop="${drop}"]`);
        let menus = $('#submenu_grid_mobile').find('.submenu_dropdown_trigger_mobile');
        Array.from(menus).forEach( (el) => {
            if ( $(el).data('drop') === drop ){
                $(el).addClass('stop');
            }else{
                $(el).addClass('hide');
            }
        })
        $(target).animate({
            right: '0'
        }).addClass('active');
    })
    $('.btn_dropdown_close_mobile').on('click', function(){
        let drop = $(this).data('drop');
        let target = $('#submenu_grid_mobile').find(`.header-vape__submenu-container[data-drop="${drop}"]`);
        let menus = $('#submenu_grid_mobile').find('.submenu_dropdown_trigger_mobile');
        $('#submenu_grid_mobile').removeClass('open');
        Array.from(menus).forEach( (el) => {
            if ( $(el).data('drop') === drop ){
                $(el).removeClass('stop');
            }else{
                $(el).removeClass('hide');
            }
        });
        $(target).animate({
            right: '-100%'
        }).delay(100).removeClass('active');
        if( $('#bundle-builder-app--bundle--alert').length ){
            $('#bundle-builder-app--bundle--alert').removeClass('hide');
        }
        if( $('#wa-chat-btn-root').length){
            $('#wa-chat-btn-root').removeClass('hide');
        }
    })
}